import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class extends Controller<HTMLSelectElement> {
  static readonly values = {
    key: String,
    placeholder: String,
    searchPlaceholder: String,
    tabindex: Number
  };

  declare readonly keyValue: string;
  declare readonly placeholderValue: string;
  declare readonly searchPlaceholderValue: string;
  declare readonly tabindexValue: number;

  private readonly noResultsText = "No results found";
  private _slimSelect: SlimSelect;

  connect(): void {
    this._initialize();
  }

  disconnect() {
    this._slimSelect.destroy();
  }

  private _initialize() {
    this._slimSelect = new SlimSelect({
      select: this.element,
      cssClasses: {
        main: "form-select",
        arrow: "ss-hide",
      },
      settings: {
        placeholderText: this.placeholderValue,
        searchPlaceholder: this.searchPlaceholderValue,
        searchText: this.noResultsText,
      },
    });

    const slimSelectContainer = this.element.nextElementSibling;

    if (slimSelectContainer instanceof HTMLDivElement) {
      slimSelectContainer.tabIndex = this.tabindexValue;
    }

    const searchInput = document.querySelector(
      `div[data-id=${this._slimSelect.settings.id}] .ss-search input`
    );
    if (searchInput) {
      searchInput.classList.add("form-control");
    }
  }
}
